import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_ORDERS_REQUEST } from "./constants";
import { Action, OrderState } from "./types";

function items(state: OrderState = {}, action: Action): OrderState {
  switch (action.type) {
    case getSuccessActionType(FETCH_ORDERS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_ORDERS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_ORDERS_REQUEST):
    case getFailureActionType(FETCH_ORDERS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const orders = combineReducers({ items, isFetching });
